import cx from 'clsx';
import { useRouter } from 'next/router';
import { trackEvent } from '@kcd/event-tracker';

import { CATEGORY_ROUTER } from '~/constants/router';
import { useLinkComponent } from '~/hooks/mobileApp';
import { useRouterQueryByKey, useUpdateRouterQuery } from '~/hooks/url';

import {
  ChevronRightIcon,
  Home20x20Icon,
  MobileVoucher20x20Icon,
  SafeDeliveryIcon,
} from '~/assets/icons';

type Props = {
  className?: string;
  eventName?: string;
  eventProps?: {
    category?: string;
  };
};

function ProductFilters({
  className,
  eventName = 'clicked tab in 마켓/카테고리 page',
  eventProps,
}: Props) {
  const updateRouterQuery = useUpdateRouterQuery();
  const LinkComponent = useLinkComponent();
  const isSelfDelivery = useRouterQueryByKey('deliveryType', 'string');
  const productType = useRouterQueryByKey('productType', 'string');
  const isForHomeProduct = useRouterQueryByKey('isForHomeProduct', 'string');

  const { query } = useRouter();

  const handleFilterClick = (props: Record<string, string>, name: string) => {
    // TODO - 신규 이벤트 추가
    const key = Object.keys(props)[0];

    if (query[key]) {
      void updateRouterQuery({ [key]: undefined });
    } else {
      void updateRouterQuery({ [key]: props?.[key] });
    }

    trackEvent(eventName, {
      ...eventProps,
      path: window.location.pathname,
      placementName: 'filter',
      name,
    });
  };

  return (
    <div
      className={cx(
        'flex items-center gap-8 overflow-x-auto bg-screen-01 py-8 horizontal-scroll',
        className,
      )}
    >
      <button
        type="button"
        className="ml-20 scroll-mx-20 rounded-[20px] border border-04 bg-primary-air py-[5px] pl-12 pr-8"
        onClick={() => handleFilterClick({}, '카테고리')}
      >
        <LinkComponent href={CATEGORY_ROUTER.root}>
          <span className="flex gap-4 typo-caption100-semibold">
            카테고리
            <ChevronRightIcon width={20} />
          </span>
        </LinkComponent>
      </button>

      <button
        type="button"
        className={cx([
          'flex items-center gap-4 border border-02 typo-caption100-semibold py-[5px] pl-8 pr-12 rounded-[20px]',
          isSelfDelivery && '!border-secondary-heavy',
        ])}
        onClick={() => handleFilterClick({ deliveryType: 'SELF' }, '직거래')}
      >
        <SafeDeliveryIcon width={20} /> 직배송
      </button>
      <button
        type="button"
        className={cx([
          'flex items-center gap-4 border border-02 typo-caption100-semibold py-[5px] pl-8 pr-12 rounded-[20px]',
          isForHomeProduct && '!border-secondary-heavy',
        ])}
        onClick={() =>
          handleFilterClick({ isForHomeProduct: 'true' }, '가정용 상품')
        }
      >
        <Home20x20Icon width={20} />
        가정용 상품
      </button>
      <button
        type="button"
        className={cx([
          'flex items-center gap-4 border border-02 typo-caption100-semibold px-12 py-[5px] mr-20 rounded-[20px]',
          productType && '!border-secondary-heavy',
        ])}
        onClick={() =>
          handleFilterClick({ productType: 'E_COUPON' }, '모바일교환권')
        }
      >
        <MobileVoucher20x20Icon />
        모바일교환권
      </button>
    </div>
  );
}

export default ProductFilters;
